// extracted by mini-css-extract-plugin
export default {"feedItem":"FeedItem_feedItem__x+VDn","header":"FeedItem_header__MdIwO","detailText":"FeedItem_detailText__1VDbc","dot":"FeedItem_dot__aK0aH","body":"FeedItem_body__7MGAr"};